import { render, staticRenderFns } from "./pwa_article_description.vue?vue&type=template&id=f89b4f8e&scoped=true&"
import script from "./pwa_article_description.vue?vue&type=script&lang=js&"
export * from "./pwa_article_description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b4f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f89b4f8e')) {
      api.createRecord('f89b4f8e', component.options)
    } else {
      api.reload('f89b4f8e', component.options)
    }
    module.hot.accept("./pwa_article_description.vue?vue&type=template&id=f89b4f8e&scoped=true&", function () {
      api.rerender('f89b4f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article_description.vue"
export default component.exports